<template>
    <span class="ml-2">
        <Button
            v-for="field in Object.keys(loopDefaults)"
            :key="field"
            :icon="basket && basket[field] ? 'pi pi-minus' : 'pi pi-plus'"
            :label="field"
            :class="
                basket && basket[field]
                    ? 'p-button-rounded p-button-outlined p-button-sm p-button-danger mx-2'
                    : 'p-button-rounded p-button-outlined p-button-sm mx-2'
            "
            @click="addRemoveField(field)"
        />
    </span>
    <div v-if="basket" class="loopRules inter-rule-spacing ml-4 mt-2">
        <div v-for="field in Object.keys(basket)" :key="field" class="my-3 mx-3">
            <div v-if="field !== 'type'">
                <span>{{ field }}: </span>
                <StandardDropdown
                    :modelValue="{ name: basket[field]['operator'] }"
                    :options="loopDefaults[field].operators.map((o) => ({ name: o }))"
                    placeholder="Select operation"
                    class="inter-rule-spacing"
                    @change="sendBasket(field, $event.value.name, basket[field]['value'])"
                />
                <component
                    :is="loopDefaults[field]['component']['name']"
                    :value="basket[field]['value']"
                    :operator="basket[field]['operator']"
                    class="inter-rule-spacing"
                    @handleValueChange="sendBasket(field, basket[field]['operator'], $event)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import StandardDropdown from '@/components/common/StandardDropdown.vue';
import { integerOperators, dateOperators, inOperator, onlyInOperator, onlyContainsOperator } from '@/store/constants';
import IntRule from '@/components/listGeneration/query/ruleSuffix/IntRule.vue';
import TextRule from '@/components/listGeneration/query/ruleSuffix/TextRule.vue';
import DateRule from '@/components/listGeneration/query/ruleSuffix/DateRule.vue';
import StateRule from '@/components/listGeneration/query/ruleSuffix/StateRule.vue';

export default {
    name: 'DonationBasketRule',
    props: ['basket'],
    emits: ['handleBasketChange'],
    components: {
        StandardDropdown,
        IntRule,
        TextRule,
        DateRule,
        StateRule,
    },
    data() {
        return {
            loopDefaults: {
                candidates: {
                    operators: onlyInOperator.concat(onlyContainsOperator),
                    component: TextRule,
                },
                date: {
                    operators: dateOperators,
                    component: DateRule,
                },
                amount: {
                    operators: integerOperators,
                    component: IntRule,
                },
                candidate_state: {
                    operators: inOperator,
                    component: StateRule,
                },
                district: {
                    operators: integerOperators,
                    component: IntRule,
                },
            },
        };
    },
    methods: {
        addRemoveField(field) {
            let updated_basket = {};
            const default_operator = this.loopDefaults[field].operators[0];
            if (this.basket && this.basket[field]) {
                updated_basket = this.basket;
                delete updated_basket[field];
            } else if (this.basket) {
                updated_basket = this.basket;
                updated_basket[field] = {
                    value: null,
                    operator: default_operator,
                };
            } else {
                updated_basket[field] = {
                    value: null,
                    operator: default_operator,
                };
            }
            this.$emit('handleBasketChange', updated_basket);
        },
        sendBasket(field, operator, value) {
            const updated_basket = this.basket;
            updated_basket['type'] = 'basket';
            updated_basket[field] = {
                type: 'basket_field',
                value: value,
                operator: operator,
            };
            this.$emit('handleBasketChange', updated_basket);
        },
    },
};
</script>

<style scoped>
.inter-rule-spacing {
    margin-right: 0.5rem;
}
.loopRules {
    border-left: dashed;
}
</style>
